module.exports = __webpack_public_path__ + "static/services3-5ab9a318c31d48b7e241d789017a5245.png";